import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["config", "isLoggedIn", "isOpen", "onAuthSuccess", "onClose"];
var _TrackingStateMap;
import PropTypes from 'prop-types';
import React from 'react';
import { makeFieldPassTracking } from '../scripts/tracking';
import { FieldPass, FieldPassChangeReasons, FieldPassCloseReasons, FieldPassStates } from '@mlb/account-components';
var ACCOUNT_BUTTON_CLICKED = FieldPassChangeReasons.ACCOUNT_BUTTON_CLICKED,
  LOGIN_ERROR = FieldPassChangeReasons.LOGIN_ERROR,
  LOGIN_SUCCESS = FieldPassChangeReasons.LOGIN_SUCCESS,
  REGISTER_ERROR = FieldPassChangeReasons.REGISTER_ERROR,
  REGISTER_SUCCESS = FieldPassChangeReasons.REGISTER_SUCCESS,
  STATE_CHANGE = FieldPassChangeReasons.STATE_CHANGE;
var SupportedCloseReasons = [FieldPassCloseReasons.BACKDROP_CLICK, FieldPassCloseReasons.CLOSE_BUTTON_CLICK, FieldPassCloseReasons.ESCAPE_KEY_PRESS];
var LOGIN = FieldPassStates.LOGIN,
  REGISTER = FieldPassStates.REGISTER;
var TrackingStateMap = (_TrackingStateMap = {}, _defineProperty(_TrackingStateMap, LOGIN, 'Log In'), _defineProperty(_TrackingStateMap, REGISTER, 'Sign Up'), _TrackingStateMap);
var pageLoadTracking = makeFieldPassTracking({
  trackingType: null
});
var closeTracking = makeFieldPassTracking({
  trackingType: 'content navigation'
});
var triggerTracking = makeFieldPassTracking({
  trackingType: 'FieldPass'
});
var FieldPassContainer = function FieldPassContainer(_ref) {
  var config = _ref.config,
    isLoggedIn = _ref.isLoggedIn,
    isOpen = _ref.isOpen,
    onAuthSuccess = _ref.onAuthSuccess,
    onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded);
  var onFieldPassChange = function onFieldPassChange(event) {
    var reason = event.reason,
      state = event.state;
    if (reason === LOGIN_SUCCESS || reason === REGISTER_SUCCESS || reason === LOGIN_ERROR || reason === REGISTER_ERROR) {
      var isSuccessful = reason === LOGIN_SUCCESS || reason === REGISTER_SUCCESS;
      if (isSuccessful) {
        onAuthSuccess(event);
      }
      var status = isSuccessful ? 'Success' : 'Failure';
      triggerTracking({
        action: 'fieldpass-login-register',
        payload: {
          source: TrackingStateMap[state.current],
          status: status
        },
        type: 'click'
      });
    }
    if (reason === ACCOUNT_BUTTON_CLICKED) {
      var elementType = state.current === LOGIN ? REGISTER : LOGIN;
      triggerTracking({
        action: 'fieldpass',
        payload: {
          elementType: TrackingStateMap[elementType],
          source: TrackingStateMap[state.current]
        },
        type: 'click'
      });
    }
    if (reason === STATE_CHANGE && TrackingStateMap[state.current]) {
      pageLoadTracking({
        payload: {
          source: TrackingStateMap[state.current]
        },
        type: 'page-load'
      });
    }
  };
  var onFieldPassClose = function onFieldPassClose(event) {
    if (SupportedCloseReasons.includes(event.reason)) {
      closeTracking({
        action: 'fieldpass-close',
        payload: {
          elementType: event.reason,
          source: TrackingStateMap[event.state.current]
        },
        type: 'click'
      });
    }
    onClose(event);
  };
  return /*#__PURE__*/React.createElement(FieldPass, _extends({
    isLoggedIn: isLoggedIn,
    isOpen: isOpen,
    onChange: onFieldPassChange,
    onClose: onFieldPassClose
  }, config, props));
};
export default FieldPassContainer;
FieldPassContainer.propTypes = {
  config: PropTypes.shape({
    copyConfig: PropTypes.shape({}),
    loginConfig: PropTypes.shape({}),
    registerConfig: PropTypes.shape({})
  }),
  isLoggedIn: PropTypes.bool,
  isOpen: PropTypes.bool,
  onAuthSuccess: PropTypes.func,
  onClose: PropTypes.func
};
FieldPassContainer.defaultProps = {
  isLoggedIn: false,
  isOpen: false,
  onAuthSuccess: function onAuthSuccess() {},
  onClose: function onClose() {}
};